module.exports = __webpack_public_path__ + "static/media/TL.9e4f56d2.png";